import { useState } from "react";
import { NftCreatorsCard } from "../../../../components/NFT/NftCreatorsCard";
import { INftAsset } from "../../../../interfaces"

interface NftDetailRelatedAssetProps {
  creatorsAssets: INftAsset[] | null;
}
export const NftDetailRelatedAsset = ({ creatorsAssets }: NftDetailRelatedAssetProps) => {
  const [expand, setExpand] = useState<Boolean>(true);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 cursor-pointer" onClick={() => {
        setExpand(!expand);
      }}>
        <div className="">
          <span className="material-icons mr-2" style={{ verticalAlign: 'bottom', }}>list</span>
          <span className="weight-600">星河系列</span>
        </div>
        <span className="material-icons-outlined text-gray-400">{expand ? 'expand_less' : 'expand_more'}</span>
      </div>
      <div className="border-up overflow-x-auto bg-gray-50" style={{ display: '-webkit-box', height: expand ? 'auto' : '0px' }}>
        <div className="d-flex justify-content-between my-4">

          <div className="pe-4"></div>
          {
            creatorsAssets?.map((nftAsset, index) => {
              return (
                <NftCreatorsCard asset={nftAsset} key={index} />
              )
            })
          }
        </div>
      </div>
    </>
  )
}